import { Link, useLocation } from 'react-router-dom'
import { useLocale } from '../i18n'

function Navigation() {
  const location = useLocation()
  const { t, locale, setLocale } = useLocale()

  const navItems = [
    { path: '/', label: `🏠 ${t('nav.home')}` },
    { path: '/documents', label: `ℹ️ ${t('nav.docs')}` },
    { path: '/products', label: `🛍️ ${t('nav.products')}` },
    { path: '/cart', label: `🛒 ${t('nav.cart')}` },
  ]

  return (
    <nav className="nav">
      <div className="nav-top">
        <ul className="nav-list">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`nav-link ${
                  location.pathname === item.path ? 'active' : ''
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="locale-switch" aria-label={t('nav.language')}>
          <button
            className={`locale-btn ${locale === 'en' ? 'active' : ''}`}
            onClick={() => setLocale('en')}
          >
            {t('nav.en')}
          </button>
          <button
            className={`locale-btn ${locale === 'zh' ? 'active' : ''}`}
            onClick={() => setLocale('zh')}
          >
            {t('nav.zh')}
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
